import TypingIndicator from '@/shared/ui/components/TypingIndicator';
import { Box, keyframes } from '@mui/material';

const spin = keyframes`
  to { transform: translate(-50%, -50%) rotate(360deg); }
`;

/** The "…" bubble with a light running round its edge, shown while a search is in progress. */
const ThinkingBubble = ({ label }: { label: string }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      position: 'relative',
      width: 'fit-content',
      p: '1.5px',
      overflow: 'hidden',
      borderRadius: '4px 18px 18px 18px',
      // A rotating conic gradient behind the bubble; only its 1.5px edge shows.
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '300%',
        aspectRatio: '1',
        background: theme =>
          `conic-gradient(transparent 0deg, transparent 250deg, ${theme.palette.primary.light} 310deg, ${theme.palette.secondary.main} 360deg)`,
        animation: `${spin} 2.4s linear infinite`,
        transform: 'translate(-50%, -50%)'
      }
    }}
  >
    <Box sx={{ position: 'relative', bgcolor: 'background.paper', borderRadius: '3px 17px 17px 17px', px: 1.75, py: 0.25 }}>
      <TypingIndicator isTyping label={label} />
    </Box>
  </Box>
);

export default ThinkingBubble;
